import React, { useState } from 'react';
import { ParsedFragmentEntity } from '@entities/ParsedFragment/Types';
import { useParams } from 'react-router-dom';
import { useProjectStore } from '../../../../../../Stores/ProjectStore';
import {
    notifyErrorCustom,
    notifySuccessCustom,
} from '@shared/Widgets/ToastNotifications/ToastNotifications';
import { MobileStepContentElementWrapper } from '@modules/Steps/Shared/Ui/Wrappers/MobileStepContentElementWrapper/MobileStepContentElementWrapper';
import { FragmentInfoMobileDropdown } from '@modules/Steps/Components/Step2/Step2MobileContent/FragmentInfoMobileStep2/FragmentInfoMobileDropdown/FragmentInfoMobileDropdown';
import ItemProgressBar from '@shared/Ui/ProgressBars/ItemProgressBar/ItemProgressBar';
import css from './FragmentInfoMobileStep2.module.css';
import { FragmentInfoFooterStep2 } from '@modules/Steps/Components/Step2/Step2DesktopContent/FragmentInfoStep2/FragmentInfoFooterStep2/FragmentInfoFooterStep2';
import { ItemTypesListMobile } from '@modules/Steps/Components/Step2/Step2MobileContent/FragmentInfoMobileStep2/ItemTypesListMobile/ItemTypesListMobile';
import { FragmentsViewModel } from '@viewModels/FragmentsViewModel/FragmentsViewModel';

interface FragmentInfoMobileStep2Props {
    fragment: ParsedFragmentEntity;
}

export const FragmentInfoMobileStep2: React.FC<
    FragmentInfoMobileStep2Props
> = ({ fragment }) => {
    const { progress, itemTypes } = fragment;
    const [expanded, setExpanded] = useState(false);
    const {
        // fetchUpdateParsedFragment,
        // getItemTypesTotal,
        // getGalleryUrlByFragmentId,
    } = useProjectStore();

    const fragmentsViewModel = new FragmentsViewModel();
    const toggleExpand = () => {
        setExpanded(!expanded);
    };

    const { id, title } = fragment;
    const url = fragmentsViewModel.getFragmentGallery(id);

    const filteredItemTypes = itemTypes.filter(itemType => itemType.qty > 0);

    const handleSave = async () => {
        const response = await fragmentsViewModel.updateParsedFragment(
            fragment.uuid
        );
        if (!response) {
            notifyErrorCustom('Failed update fragment');
            return;
        }

        notifySuccessCustom('Fragment updated successfully');
    };

    const totalPrice = fragmentsViewModel.getItemTypesTotal(itemTypes);

    return (
        <MobileStepContentElementWrapper>
            <FragmentInfoMobileDropdown
                isExpanded={expanded}
                toggleExpand={toggleExpand}
                isLaborAndTools={false}
                imgUrl={url}
                fragmentTitle={title}
            />

            <div className={`${css.itemTypesList} ${expanded ? css.show : ''}`}>
                <div className={css.progressBar}>
                    <ItemProgressBar
                        total={100}
                        current={progress}
                        selectedNotify={'%'}
                    />
                </div>
                <ItemTypesListMobile itemTypes={filteredItemTypes} />

                <FragmentInfoFooterStep2
                    totalPrice={totalPrice}
                    onSave={handleSave}
                />
            </div>
        </MobileStepContentElementWrapper>
    );
};
